import React from 'react'
import EmployeeTypeSelect from './EmployeeTypeSelect'
import { compact, without } from 'lodash'
import MultiSelect from './MultiSelect'

interface MultiEmployeeTypeSelectProps {
  values: string[]
  onChange: (items: string[]) => void
}

export default function MultiEmployeeTypeSelect({
  values,
  onChange,
}: MultiEmployeeTypeSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title="Employee Types"
      values={values.map((v, i) => (
        <span key={v}>{v}</span>
      ))}
      select={
        <EmployeeTypeSelect
          multi
          btnText="Add"
          itemDisabled={(item) => values.includes(item)}
          onChange={(et) =>
            et && !!values.find((v) => v === et)
              ? onChange(without(values, et))
              : onChange(compact([...values, et]))
          }
          value={null}
          {...{ buttonProps }}
        />
      }
      onRemove={(v) => onChange(values.filter((av) => av !== v))}
    />
  )
}
